import React, { useEffect, useState, useRef, useCallback } from 'react';
import Filters from './FiIlters';
import {
    createCommissionReport,
    fetchBusByPid,
    fetchCommissionReports,
    getDropdowns,
    getFilterFormFields,
    sapPosting,
    filterOwnedBu,
} from './utils';
import {
    dummyViewData,
    EMPTY_FILTER_FORM,
    formatProcessData,
    processData
} from './constant';
import ALoader from 'views/pages/manage/common/a-loader';
import { ReactComponent as BackArrow } from "assets/img/svg/BackArrow.svg";

import { useHistory } from 'react-router-dom';
import ProcessCard from './ProcessCard';
import GenerateCommissionDialog from './GenerateCommissionDialog';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import SendReportDialog from './SendReportDialog';
import SapPostingDialog from './SapPostingDialog';
import { useSelector } from 'react-redux';
import { updateRequest } from 'views/pages/manage/edpOps/constant/common';
import TablePagination from 'modules/paymentManagement/cash-management/components/TablePagination';
import styles from "./processCard.module.scss";
import moment from 'moment';
import { getAppliedFilterCount } from 'modules/studentTransfer/components/searchStudent/studentTransfersListing/utils';
import { useGetPermissions } from 'layouts/customHook';

const USE_INFINITE_SCROLL = false;

const CommissionReport = ({ userPermissions }) => {

    const observerRef = useRef(null);

    const [paginationInfo, setPaginationInfo] = useState({
        currPageNo: 0,
        currPageSize: 10,
        totalRecords: 0,
        totalPage: 0
    });

    const [filterForm, setFilterForm] = useState(EMPTY_FILTER_FORM);
    const [loading, setLoading] = useState(false);
    const [reportList, setReportsList] = useState([]);

    const [openGenerateDialog, setOpenGenerateDialog] = useState(false);
    const [openSendEmailDialog, setOpenSendEmailDialog] = useState(null);
    const [openSapPostingDialog, setOpenSapPostingDialog] = useState(null);

    const isBulkAccess = userPermissions.includes("B");
    const isCreateAccess = userPermissions.includes("C") || userPermissions.includes("U")
    const sapUserPermission = useGetPermissions('commissionReportSapPosting')||[];
    const isSapPostingPermission = sapUserPermission.includes("C") || sapUserPermission.includes("U");
    const history = useHistory();
console.log('sapPosting', isSapPostingPermission)
    const handleFilterForm = (key, val) =>
        setFilterForm(prev => ({ ...prev, [key]: val }));

    const masterDropdowns = useSelector(
        (state) => state.globalData.masterDropdowns
    );

    const [dropdownData, setDropdownData] = useState({
        businessAreas: masterDropdowns?.businessArea
    });

const getCommissionReports = async ({
    filters = filterForm,
    offset = 0,
    pageSize = paginationInfo.currPageSize,
    append = false
}) => {
    try {
        setLoading(true);

        const businessAreaList =
            filters?.businessArea?.length
                ? filters.businessArea.map(item => item?.label)
                : (dropdownData?.businessAreas || []).map(item => item?.label);

        const reqObj = {
            ...filters,
            businessArea: businessAreaList,
            businessAreaType: filters?.businessAreaType.map(item => item?.label) ,
            processRunFrom: filters?.processRunFrom
                ? moment(filters.processRunFrom).format("YYYY-MM-DD")
                : null,
            processRunTo: filters?.processRunTo
                ? moment(filters.processRunTo).format("YYYY-MM-DD")
                : null
        };

        const resp = await fetchCommissionReports({
            filters: updateRequest(reqObj),
            offset,
            pageSize
        });

        const {
            totalElements = 0,
            pageNumber = 0,
            totalPages = 0,
            content = []
        } = resp?.data || {};

        setReportsList(prev =>
            append ? [...(prev || []), ...content] : content
        );

        setPaginationInfo(prev => ({
            ...prev,
            totalRecords: totalElements,
            currPageNo: pageNumber,
            currPageSize: pageSize,
            totalPage: totalPages
        }));

        setFilterForm(prev => ({
            ...prev,
            ...filters,
            appliedFilterCount: getAppliedFilterCount(filters)
        }));

    } catch (err) {
        console.error("Error fetching commission reports:", err);
    } finally {
        setLoading(false);
    }
};

    const init = async () => {
        setLoading(true);
        try {
            const [dropdownRes, reportRes] = await Promise.all([
                getDropdowns(),
                getCommissionReports({ offset: 0 })
            ]);

            // Safe destructuring
            const businessUnitType = dropdownRes?.businessUnitType || [];

            // Pre-compute derived values
            const filteredBusinessUnitType = businessUnitType.filter(
                item => item?.label !== "Owned"
            );
            debugger
            const businessAreas = filterOwnedBu(
                masterDropdowns?.businessArea,
                businessUnitType
            );

            setDropdownData(prev => ({
                ...prev,
                ...dropdownRes,
                businessAreas,
                businessUnitType: filteredBusinessUnitType
            }));

        } catch (err) {
            console.error("Init API failed:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        init();
    }, []);


    const lastElementRef = useCallback(node => {
        if (!USE_INFINITE_SCROLL || loading) return;

        if (observerRef.current) observerRef.current.disconnect();

        observerRef.current = new IntersectionObserver(entries => {
            if (
                entries[0].isIntersecting &&
                paginationInfo.currPageNo + 1 < paginationInfo.totalPage
            ) {
                getCommissionReports({
                    offset: paginationInfo.currPageNo + 1,
                    append: true
                });
            }
        });

        if (node) observerRef.current.observe(node);
    }, [loading, paginationInfo]);


    const generateCommissionReport = async (payload) => {
        try {
            setLoading(true);
            const res = await createCommissionReport(payload);
            if (res?.code === 200) {
                getCommissionReports({ offset: 0 });
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const emailPopupHandler = (processObj) => {
        setOpenSendEmailDialog(processObj);
    };

    const sapPotingPopupHandler = (processObj) => {
        setOpenSapPostingDialog(processObj);
    };


    const onPageChange = (page) => {
        getCommissionReports({
            offset: page,
            pageSize: paginationInfo.currPageSize,
        });
    };

    const onPageSizeChange = (size) => {
        getCommissionReports({
            offset: 0,
            pageSize: size,
        });
    };

    const pagination = {
        total: paginationInfo.totalRecords,
        page: paginationInfo.currPageNo,
        pageSize: paginationInfo.currPageSize,
        totalPages: paginationInfo.totalPage,
    };
    const isEmpty = paginationInfo.totalRecords === 0;

    return (
        <>
            <div className='a-card'>
                {loading && <ALoader position={"fixed"} zIndex={120} />}

                <div className='d-flex justify-content-between mb-3'>
                    <div className='d-flex align-items-center'>
                        <BackArrow className='mr-2 cursor' onClick={() => history.goBack()} />
                        <h3 className='mb-0'>Commission Report</h3>
                    </div>

                    <div className='d-flex' style={{ gap: '6px' }}>
                        <Filters
                            filterForm={filterForm}
                            handleFilterForm={handleFilterForm}
                            getList={(params) => getCommissionReports({ ...params, offset: 0 })}
                            getFilterFormFields={getFilterFormFields}
                            EMPTY_FILTER_FORM={EMPTY_FILTER_FORM}
                            dropdowns={dropdownData}
                        />

                        {!isEmpty && (isBulkAccess || isCreateAccess) && (
                            <AButton
                                variant="primary_filled"
                                onClick={() => setOpenGenerateDialog(true)}
                                size="xs"
                            >
                                Generate Report
                            </AButton>
                        )}
                    </div>
                </div>
            </div>
            {isEmpty && !loading && (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "60vh", // full center feel
                        flexDirection: "column",
                        gap: "12px"
                    }}
                >
                    <h4 style={{ color: "#666", fontWeight: 500 }}>
                        No Reports Available
                    </h4>

                    {isEmpty && !loading && (isBulkAccess || isCreateAccess) && <AButton
                        variant="primary_filled"
                        onClick={() => setOpenGenerateDialog(true)}
                        size="md"
                    >
                        Generate Report
                    </AButton>
                    }
                </div>
            )}

            {/* PROCESS CARDS */}
            {formatProcessData(reportList || processData).map((p, index) => {
                const isLast = index === reportList.length - 1;

                return (
                    <div ref={isLast ? lastElementRef : null} key={p.id}>
                        <ProcessCard
                            data={p}
                            emailPopupHandler={emailPopupHandler}
                            sapPotingPopupHandler={sapPotingPopupHandler}
                            userPermissions={userPermissions}
                            isBulkAccess={isBulkAccess}
                            isCreateAccess={isCreateAccess}
                            loading={loading}
                            setLoading={setLoading}
                            isSapPostingPermission={isSapPostingPermission}
                        />
                    </div>
                );
            })}

            {/* DIALOGS */}
            <GenerateCommissionDialog
                generateCommissionReport={generateCommissionReport}
                dropdownData={dropdownData}
                open={openGenerateDialog}
                onClose={() => setOpenGenerateDialog(false)}
                isBulkAccess={isBulkAccess}
                isCreateAccess={isCreateAccess}
            />

            <SendReportDialog
                getCommissionReports={getCommissionReports}
                open={!!openSendEmailDialog}
                processId={openSendEmailDialog?.id}
                processDetails={openSendEmailDialog}
                onClose={() => setOpenSendEmailDialog(null)}
                isViewOnly={false}
                viewData={dummyViewData}
                businessAreas={dropdownData?.businessAreas}
            />

            <SapPostingDialog
                open={!!openSapPostingDialog}
                processDetails={openSapPostingDialog?.raw}
                onClose={() => setOpenSapPostingDialog(null)}
                getCommissionReports={getCommissionReports}
                businessAreas={dropdownData?.businessAreas}
            />

            {!USE_INFINITE_SCROLL && pagination.totalPages > 0 && (
                <div className={styles.paginationStickyContainer}>
                    <TablePagination
                        loading={loading}
                        pagination={pagination}
                        onPageChange={onPageChange}
                        onPageSizeChange={onPageSizeChange}
                    />
                </div>
            )}
        </>
    );
};

export default CommissionReport;